import * as serverApi from './server';

export const login = (payload) => serverApi.post('/auth', payload);
export const forgotPassword = (payload) => serverApi.post('/auth/forgot-password', payload);
export const resetPassword = ({ token, ...payload }) =>
  serverApi.post(`/auth/reset-password/${token}`, payload);
export const changePassword = (payload) => serverApi.post('/auth/change-password', payload);
export const updatePassword = (payload) => serverApi.post('/auth/update-password', payload);
